<template>
  <div class="mb-100">
    <div class="divider-full"></div>
    <div class="cotainer-standar">
      <div class="container-standar mb-10 pad-20">
        <!-- <h4 class="font-weight-7 text-primary font-20 bor-bot-1 mb-30 pb-4">Profil Desa Hanjuang</h4> -->
        <div class="text-center" v-if="loading">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
        <div class="row" v-else>
          <div class="col-lg-12 col-xs-12">
            <div class="card shadow border-radius-10 pad-10 detail-potensi">
              <div class="card-header py-0" style="background-color: transparent !important;">
                <h3 class="font-24 text-primary font-weight-7 my-1">
                  Detail informasi desa/kampung {{ this.items.name }}
                </h3>
              </div>
              <div class="card-body pt-0">
                <b-tabs content-class="mt-3 pad-10" v-model="activeTab" @input="onTabChange">
                  <b-tab title="Profile" active>
                    <div class="row px-3">
                      <div class="col-lg-3 col-xs-12">
                        <div class="row form-group my-1 cont-img">
                          <b-img src="https://pbs.twimg.com/media/DHlpbuPUwAANT69.jpg" alt fill />
                        </div>
                        <label class="col-lg-12 mb-1 text-center text-primary font-weight-7">Visi</label>
                        <label class="col-lg-12 text-danger text-center font-weight-7 pb-3">"The quick brown fox jumps over the lazy dog"</label>
                        <label class="col-lg-12 mb-1 text-center text-primary font-weight-7">Misi</label>
                        <label class="col-lg-12 text-danger text-center font-weight-7 mb-3">"The quick brown fox jumps over the lazy dog"</label>
                      </div>
                      <div class="col-lg-9 col-xs-12 pl-5">
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Kode desa/kampung</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.code }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Nama desa/kampung</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.name }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Nama kepala desa/kampung</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.chairman_name }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Tahun pembentukan</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1"></label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Dasar hukum</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1"></label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Provinsi</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1"></label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Kabupaten/Kota</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.cities.name }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Distrik</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.districts.name }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Alamat sekretariat</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.address }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Telepon</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1"></label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Kodepos</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.kodepos }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Email</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1"></label>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="Data Statistik">
                    <div class="row px-3">
                      <div class="col-lg-6 col-xs-12">
                        <legend class="font-weight-7 font-18 text-primary">
                            Informasi demografis
                        </legend>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Jumlah keluarga</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.perkiraan_jumlah_keluarga.toLocaleString() }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Jumlah penduduk</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.jumlah_penduduk.toLocaleString() }} jiwa</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Penduduk laki-laki</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.jumlah_male.toLocaleString() }} jiwa</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-5 mb-1">Penduduk perempuan</label>
                          <label class="col-lg-7 text-primary text-right font-weight-7 mb-1">{{ this.items.jumlah_female.toLocaleString() }} jiwa</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Penduduk OAP</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1"> jiwa</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Penduduk non OAP</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1"> jiwa</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-5 mb-1">Sumber penghasilan utama</label>
                          <label class="col-lg-7 text-primary text-right font-weight-7 mb-1">{{ this.items.sumber_penghasilan_utama }}</label>
                        </div>

                        <legend class="font-weight-7 font-18 text-primary pt-5">
                            Informasi geografis
                        </legend>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Luas wilayah</label>
                          <span v-if="this.items.luas_wilayah !== null">
                            <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.luas_wilayah.toLocaleString() }} Km&sup2;</label>
                          </span>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Ketinggian</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1"></label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Batas utara</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1"></label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Batas timur</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1"></label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Batas selatan</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1"></label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Batas barat</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1"></label>
                        </div>

                        <legend class="font-weight-7 font-18 text-primary pt-5">
                            Sarana kesehatan
                        </legend>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Puskesmas</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.puskesmas }}</label>
                        </div>
                      </div>
                      <div class="col-lg-6 col-xs-12 pl-5">
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Posyandu</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.posyandu }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Pondok bersalin</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.pondok_bersalin }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Dokter</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.dokter }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Bidan</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.bidan }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-5 mb-1">Tenaga kesehatan lainnya</label>
                          <label class="col-lg-7 text-primary text-right font-weight-7 mb-1">{{ this.items.tenaga_kesehatan_lainnya }}</label>
                        </div>

                        <legend class="font-weight-7 font-18 text-primary pt-5">
                            Sarana pendidikan
                        </legend>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">PAUD / sederajat</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.paud }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">TK / sederajat</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.tk }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">SD / sederajat</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.sd }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">SMP / sederajat</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.smp }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">SMA / sederajat</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.sma }}</label>
                        </div>

                        <legend class="font-weight-7 font-18 text-primary pt-5">
                            Sarana umum
                        </legend>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Masjid</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.masjid }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Gereja</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.count_gereja }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Pasar</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.count_pasar }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Balai pertemuan</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.count_balai_pertemuan }}</label>
                        </div>
                        <div class="row form-group my-1" style="border-bottom: 1px dotted gray;">
                          <label class="col-lg-4 mb-1">Lokasi industri</label>
                          <label class="col-lg-8 text-primary text-right font-weight-7 mb-1">{{ this.items.jumlah_lokasi_industri }}</label>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="Peta">
                    <div class="row px-3">
                      <div class="col-lg-12 col-xs-12" style="position: relative;">
                        <mapKampung v-if="isGISLoaded" style="position: relative;"/>
                      </div>
                      <div class="col-lg-12 col-xs-12">
                        
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
              <div class="card-footer text-center pt-3 pb-1" style="background-color: transparent !important;">
                <a href="../potensi-kampung" type="button" class="btn btn-danger">Kembali</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const potensiKampung = createNamespacedHelpers("potensiKampung");

import mapKampung from "@/components/map_kampung";

export default {
  name: 'peta_potensi',
  components: {
    mapKampung
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 10,
      center: [-0.8667, 134.0833],

      items: [],
      activeTab: 0,
      isGISLoaded: false
    };
  },
  computed: {
    ...potensiKampung.mapState(["potensiKampung", "loading"]),
  },
  created() {
    this.getDetail(this.$route.params.id);
    // this.getPotensiKampungById(this.$route.params.id);
  },
  mounted() {
    this.$store.commit("SET_BG", false);
  },
  methods: {
    ...potensiKampung.mapActions(["getPotensiKampungById"]),

    onTabChange(newTabIndex) {
      this.activeTab = newTabIndex;
      if(this.activeTab === 2 && !this.isGISLoaded){
        this.isGISLoaded = true;
      }
    },

    async getDetail(village_id) {
      await this.getPotensiKampungById(village_id)
        .then((response) => {
          this.items = response.data[0];
          console.log(this.items); 
        })
      .catch((error) => {
        console.error("Error fetching data : ", error);
      })
      .finally(() => {
        console.error("");
      });
    },
  },
};
</script>
